import {useContext} from "react";
import {PreloaderContext, PreloaderContextType} from "../context/PreloaderContext";

export function usePreloader() : PreloaderContextType {
    return useContext(PreloaderContext);
}
